var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60024 7.4L14.0002 2M14.0002 2H10.794M14.0002 2V5.20625M14.0002 8C14.0002 10.8284 14.0002 12.2426 13.1216 13.1213C12.2429 14 10.8287 14 8.00024 14C5.17182 14 3.7576 14 2.87892 13.1213C2.00024 12.2426 2.00024 10.8284 2.00024 8C2.00024 5.17157 2.00024 3.75736 2.87892 2.87868C3.7576 2 5.17182 2 8.00024 2",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.2b8c72d5442badb1c5e3e7f060147ac5.svg";
export { ForwardRef as ReactComponent };